document.addEventListener('alpine:init', () => {
  Alpine.data('ContactEmailContentBlock', () => ({
    toolTipShow: false,

    hasCopied: false,

    init() {
      this.$watch('toolTipShow', (val) => {
        if (!val) {
          setTimeout(() => {
            this.hasCopied = false
          }, 500)
        }
      })
    },

    async handleEmailClick(e) {
      e.preventDefault()
      const email = e.srcElement.innerText
      navigator.clipboard.writeText(email).then(() => {
        this.hasCopied = true
      })
    }
  }))

  Alpine.data('ContactUsForm', () => ({
    contactErrors: null,
    contactFormEl: document.getElementById('ContactForm'),
    emailValid: false,

    init () {
      if (this.contactFormEl !== null) {
        this.contactFormEl.querySelector('.contact-form__submit-button').setAttribute('disabled', 'disable');
        Array.from(this.contactFormEl.querySelectorAll('.field__input--required')).forEach(field => {
          field.addEventListener("keyup", (event) => {
            const parent = event.target.closest('.field')
      
            if (event.target.value.length === 0 ) {
              event.target.setAttribute("aria-invalid", "true")
              event.target.classList.add("field-error")
              parent.querySelector('.js-field--input-error')?.classList.remove('hidden')
      
              this.checkFields()
              return
            }
      
            event.target.removeAttribute("aria-invalid")
            event.target.classList.remove("field-error")
            parent.querySelector('.js-field--input-error')?.classList.add('hidden')
      
            this.checkFields()
          })
        })
      }
    },
    
    checkFields() {
      const hasEmptyFields = Array.from(this.contactFormEl.querySelectorAll('.field__input--required, #ContactForm-email')).filter(field => !field.value.length)
  
      if (hasEmptyFields.length >= 1 || !this.emailValid) {
        this.contactFormEl.querySelector('.contact-form__submit-button').setAttribute('disabled', 'disable')
        return
      }
      
      this.contactFormEl.querySelector('.contact-form__submit-button').removeAttribute('disabled')
    },

    interactEmailField(e) {
      const items = {
        email: e.target.value
      }

      const validationRules = {
        email: ['required', 'email'],
      }

      const validation = Iodine.assert(items, validationRules)

      this.contactErrors = validation?.fields

      this.emailValid = validation?.valid
      this.checkFields()
    },

    handleSubmitContact(e) {
      this.contactErrors = null
      const formData = Object.fromEntries(new FormData(this.$refs.contactForm))
      const { 'contact[email]': email } = formData

      const validationRules = {
        email: ['required', 'email'],
      }

      const validation = Iodine.assert({ email }, validationRules)

      if(validation?.valid) return

      e.preventDefault()
      this.contactErrors = validation?.fields

      const formEl = document.getElementById('ContactForm');
      document.querySelectorAll('.js-field--input-error').forEach(field => field.classList.add('hidden'))
      document.querySelectorAll('.field__input').forEach(field => field.classList.remove('field-error'))
  
      const emptyFields = Array.from(formEl.querySelectorAll('.field__input--required')).filter(field => !field.value.length);
      if (emptyFields.length) {
        e.preventDefault();
        formEl.removeAttribute("onsubmit")
      }
  
      emptyFields.forEach(field => {
        const parent = field.parentElement
        parent.querySelector('.js-field--input-error').classList.remove('hidden');
        parent.querySelector('.field__input').classList.add('field-error');
      })
      
  
      if (emptyFields.length) return false
  
      // window.Shopify.recaptchaV3.addToken(formEl, "ContactForm")
      return false
    }
  }))
})

